import React from 'react';
import { FormattedMessage } from 'react-intl';
import styles from './ValidationIssuesReport.module.css';
import { Link } from 'react-router-dom'; // Assuming React Router is used
import EditButton from '../../../components/Button/EditButton';
import { PrimaryButtonInline } from '../../../components';

const ValidationIssuesReport = ({ requiredData, intl }) => {
  const openLink = url => {
    // Opens the URL in a new tab
    window.open(url, '_blank');
  };
  const findNullOrUndefinedValues = data => {
    return data.map((entry, index) => {
      const companyMissingFields = entry?.company
        ?.filter(item => item.value == null)
        .map(item => (
          <b key={`company-field-${item.name}`} className={styles.boldField}>
            {intl.formatMessage({ id: `Polling.requiredData.company.${item.name}` })}
          </b>
        ));

      const individualMissingFields = entry.individual
        .filter(item => item.value == null)
        .map(item => (
          <b key={`individual-field-${item.name}`} className={styles.boldField}>
            {intl.formatMessage({ id: `Polling.requiredData.individual.${item.name}` })}
          </b>
        ));

      return (
        <div key={`entry-${index}`} className={styles.entry}>
          {/* <h3 className={styles.entryTitle}>
            {intl.formatMessage(
              {
                id: 'ValidationIssuesReport.entryTitle',
                defaultMessage: 'Entry {index} Issues:',
              },
              { index: index + 1 }
            )}
          </h3> */}
          {companyMissingFields?.length > 0 && (
            <div>
              <p className={styles.issue}>
                {intl.formatMessage(
                  {
                    id: 'ValidationIssuesReport.sectionIssues',
                    defaultMessage:
                      'The following fields in the {section} section are required: {fields}.',
                  },
                  {
                    section: (
                      <b className={styles.boldFieldSection}>
                        {intl.formatMessage({
                          id: 'MyBusinessPage.title',
                          defaultMessage: 'company',
                        })}
                      </b>
                    ),
                    fields: <>{companyMissingFields.reduce((prev, curr) => [prev, ', ', curr])}</>,
                  }
                )}
              </p>
              <a target="_blank" href="/business/my-business">
                <PrimaryButtonInline
                  onClick={() => {
                    openLink('/business/my-business');
                  }}
                >
                  {intl.formatMessage(
                    {
                      id: 'ValidationIssuesReport.editLink',
                    },
                    {
                      section: (
                        <b className={styles.boldFieldSection}>
                          {intl.formatMessage({
                            id: 'MyBusinessPage.title',
                          })}
                        </b>
                      ),
                    }
                  )}
                </PrimaryButtonInline>
              </a>
              {/* <Link to="/business/my-business" className={styles.editLink}>
                {intl.formatMessage({
                  id: 'ValidationIssuesReport.companyEditLink',
                  defaultMessage: 'Edit Company Information',
                })}
              </Link> */}
            </div>
          )}
          {individualMissingFields?.length > 0 && (
            <div>
              <p className={styles.issue}>
                {intl.formatMessage(
                  {
                    id: 'ValidationIssuesReport.sectionIssues',
                    defaultMessage:
                      'The following fields in the {section} section are required: {fields}.',
                  },
                  {
                    section: (
                      <b className={styles.boldFieldSection}>
                        {intl.formatMessage({
                          id: 'ContactDetailsPage.title',
                          defaultMessage: 'individual',
                        })}
                      </b>
                    ),
                    fields: (
                      <>{individualMissingFields.reduce((prev, curr) => [prev, ', ', curr])}</>
                    ),
                  }
                )}
              </p>
              <a target="_blank" href="/account/contact-details">
                <PrimaryButtonInline
                  onClick={() => {
                    openLink('/account/contact-details');
                  }}
                >
                  {intl.formatMessage(
                    {
                      id: 'ValidationIssuesReport.editLink',
                    },
                    {
                      section: (
                        <b className={styles.boldFieldSection}>
                          {intl.formatMessage({
                            id: 'ContactDetailsPage.title',
                            defaultMessage: 'individual',
                          })}
                        </b>
                      ),
                    }
                  )}
                </PrimaryButtonInline>
              </a>
            </div>
          )}
        </div>
      );
    });
  };

  const issues = findNullOrUndefinedValues(requiredData);

  return (
    <div className={styles.container}>
      {issues?.length > 0 ? (
        issues
      ) : (
        <p className={styles.noIssues}>
          {intl.formatMessage({
            id: 'ValidationIssuesReport.noIssues',
            defaultMessage: 'No issues found!',
          })}
        </p>
      )}
    </div>
  );
};

export default ValidationIssuesReport;
